import { useState, useCallback } from 'react'

import useApiPut from 'Pods/Shared/Hooks/useApiPut'
import useNotifications from 'Pods/Shared/Hooks/useNotifications'

const API_PATH = '/api/internal/profile/sales/update/discounts'

function useJoinProgram({ messages, onSuccess, keepOpenOnSuccess = false }) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { putData, isLoading: isJoining } = useApiPut()
  const { showSuccess, showError } = useNotifications()

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleJoinProgram = useCallback(() => {
    putData({
      path: API_PATH,
      data: { discounts: { sell_for_equity: true } },
      onSuccess: () => {
        showSuccess(messages.success)
        if (!keepOpenOnSuccess) setIsModalOpen(false)
        if (onSuccess) onSuccess()
      },
      onError: () => {
        showError(messages.error)
      },
    })
  }, [putData, showSuccess, showError, messages, onSuccess, keepOpenOnSuccess])

  return {
    isModalOpen,
    isJoining,
    handleOpenModal,
    handleCloseModal,
    handleJoinProgram,
  }
}

export default useJoinProgram
